import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, List, Icon } from 'semantic-ui-react';
import { StyledModal } from './SharedStyles';
import * as api from '../services/api';

const DelegateRosterModal = ({ open, onClose }) => {
  const [delegates, setDelegates] = useState([]);
  const [newName, setNewName] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newMobile, setNewMobile] = useState('');
  const [editingUuid, setEditingUuid] = useState(null);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    if (open) loadDelegates();
  }, [open]);

  const loadDelegates = async () => {
    try {
      const data = await api.getDelegates();
      setDelegates(data);
    } catch (err) {
      console.error('Error loading delegates:', err);
    }
  };

  const handleAdd = async () => {
    if (!newName.trim()) return;
    try {
      await api.createDelegate({ name: newName.trim(), email: newEmail.trim(), mobile: newMobile.trim() });
      setNewName('');
      setNewEmail('');
      setNewMobile('');
      loadDelegates();
    } catch (err) {
      console.error('Error creating delegate:', err);
    }
  };

  const handleEditStart = (delegate) => {
    setEditingUuid(delegate.uuid);
    setEditData({ name: delegate.name, email: delegate.email, mobile: delegate.mobile });
  };

  const handleEditSave = async () => {
    try {
      await api.updateDelegate(editingUuid, editData);
      setEditingUuid(null);
      setEditData({});
      loadDelegates();
    } catch (err) {
      console.error('Error updating delegate:', err);
    }
  };

  const handleDelete = async (uuid) => {
    try {
      await api.deleteDelegate(uuid);
      loadDelegates();
    } catch (err) {
      console.error('Error deleting delegate:', err);
    }
  };

  return (
    <StyledModal open={open} onClose={onClose}>
      <Modal.Header>Manage Delegates</Modal.Header>
      <Modal.Content>
        <Form onSubmit={(e) => { e.preventDefault(); handleAdd(); }}>
          <Form.Group widths="equal">
            <Form.Input
              placeholder="Name"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
            />
            <Form.Input
              placeholder="Email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
            />
            <Form.Input
              placeholder="Mobile"
              value={newMobile}
              onChange={(e) => setNewMobile(e.target.value)}
            />
          </Form.Group>
          <Button type="submit" primary size="small" disabled={!newName.trim()}>
            Add Delegate
          </Button>
        </Form>

        <List divided relaxed style={{ marginTop: '1.5em' }}>
          {delegates.map(d => (
            <List.Item key={d.uuid}>
              {editingUuid === d.uuid ? (
                <List.Content>
                  <Form onSubmit={(e) => { e.preventDefault(); handleEditSave(); }}>
                    <Form.Group widths="equal">
                      <Form.Input
                        value={editData.name}
                        onChange={(e) => setEditData(prev => ({ ...prev, name: e.target.value }))}
                      />
                      <Form.Input
                        value={editData.email}
                        onChange={(e) => setEditData(prev => ({ ...prev, email: e.target.value }))}
                      />
                      <Form.Input
                        value={editData.mobile}
                        onChange={(e) => setEditData(prev => ({ ...prev, mobile: e.target.value }))}
                      />
                    </Form.Group>
                    <Button size="mini" positive onClick={handleEditSave}>Save</Button>
                    <Button size="mini" onClick={() => setEditingUuid(null)}>Cancel</Button>
                  </Form>
                </List.Content>
              ) : (
                <List.Content style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <strong>{d.name}</strong>
                    {d.email && <span style={{ marginLeft: '1em', color: '#666' }}>{d.email}</span>}
                    {d.mobile && <span style={{ marginLeft: '1em', color: '#666' }}>{d.mobile}</span>}
                  </div>
                  <div>
                    <Icon name="edit" link onClick={() => handleEditStart(d)} style={{ marginRight: '0.5em' }} />
                    <Icon name="trash" link color="red" onClick={() => handleDelete(d.uuid)} />
                  </div>
                </List.Content>
              )}
            </List.Item>
          ))}
          {delegates.length === 0 && (
            <List.Item>
              <List.Content>
                <em>No delegates yet. Add one above.</em>
              </List.Content>
            </List.Item>
          )}
        </List>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Close</Button>
      </Modal.Actions>
    </StyledModal>
  );
};

export default DelegateRosterModal;
